import { fetch } from "../lib/network";
import decamelizeKeys from "decamelize-keys";
import AppSettings from "../config";

export const getAccountSettings = (networkHeaders: any) => () =>
  fetch(`${AppSettings.PAYMENTS_API_URL}/accounts`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const putAccountSettings = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.PAYMENTS_API_URL}/accounts`, {
    method: "PUT",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  });

export const postAccountSettings = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.PAYMENTS_API_URL}/accounts`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  });

export const getStripeSupportStatus = (networkHeaders: any) => () =>
  fetch(`${AppSettings.PAYMENTS_API_URL}/accounts/supports_stripe`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getCashRegisters = (networkHeaders: any) => () =>
  fetch(`${AppSettings.PAYMENTS_API_URL}/cash_registers`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());
